export const TENANTS_ROUTE = `/tenants`;
export const TENANT_DETAILS_ROUTE = (tenantId: string) =>
	`${TENANTS_ROUTE}/${tenantId}`;
